import React from 'react'
import { List } from 'antd'
import styled from 'styled-components'
import { AppAvatar, PrimaryButton } from 'components'
import { GetCommentList } from 'hooks'
import { DateUtility } from 'utility'

const StyledMetaWrapper = styled.div`
  width: 100% !important;
  padding: 0;
`
const ScrollableCommentSection = styled.div`
  max-height: 520px;
  overflow-y: auto;
`
const StyledTitle = styled.span`
  font-weight: 400;
  color: #808080;
  font-size: 14px;
`

const StyledDescription = styled.span`
  color: #1a1a1a;
  font-weight: 600;
  font-size: 14px;
`
export const CommentsList = ({ id }) => {
  const { data, loading, fetchMore, hasMore } = GetCommentList(id)

  return (
    <ScrollableCommentSection>
      <List
        itemLayout="horizontal"
        dataSource={data}
        loading={loading}
        loadMore={
          hasMore ? (
            <PrimaryButton onClick={fetchMore}>Load More</PrimaryButton>
          ) : null
        }
        rowKey={item => item._id}
        renderItem={item => (
          <List.Item>
            <StyledMetaWrapper>
              <List.Item.Meta
                avatar={
                  <AppAvatar title={item.user?.name} url={item.user?.image} />
                }
                title={
                  <StyledTitle>
                    {item.user?.name} • {DateUtility.humanize(item.date)}
                  </StyledTitle>
                }
                description={<StyledDescription>{item.text}</StyledDescription>}
              />
            </StyledMetaWrapper>
          </List.Item>
        )}
      />
    </ScrollableCommentSection>
  )
}
